<template>
  <v-container
    :class="containerClasses"
    :fluid="isThisFluid"
    :style="containerStyle"
  >
    <slot />
  </v-container>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'LayoutContentContainer',
  props: {
    fluid: {
      type: Boolean,
      default: undefined,
    },
    maxWidth: {
      type: [String, Number],
      default: undefined,
    },
  },
  computed: {
    maxBreakpoint: get('app/maxBreakpoint'),
    isFluid: get('app/isFluid'),
    isThisFluid() {
      return this.fluid != undefined ? this.fluid : !!this.isFluid;
    },
    containerClasses() {
      const routeName = this.$route.name;
      return {
        'pa-0': routeName === 'AdminPlanning',
        'pa-1': routeName === 'UserShiploadsPlanning',
        'pa-md-3': routeName !== 'AdminPlanning',
      };
    },
    containerMaxWidth() {
      let width = '';
      // TODO: this.maxWidth validate breakpoint or width definition as Number or String (Number with Unit),
      if (this.maxWidth != null) {
        width = this.maxWidth;
      } else if (this.maxBreakpoint) {
        width = this.$vuetify.breakpoint.thresholds?.[this.maxBreakpoint];
      }
      return width && width + 'px';
    },
    containerStyle() {
      return this.containerMaxWidth ? { maxWidth: this.containerMaxWidth } : {};
    },
  },
};
</script>

<style lang="scss" scoped>
.v-container::v-deep {
  position: static;
}
</style>
